import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../constants";

export interface HomepageBlock3Props extends ComponentPropsWithRef<"div"> {
  header?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock3 = forwardRef<HTMLDivElement, HomepageBlock3Props>(
  ({ header, leftContent, rightContent, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <div className="wb-flex wb-flex-col wb-gap-10 md:wb-grid md:wb-grid-cols-2 md:wb-gap-16">
                <BlockSection.NestedBlock className="wb-mx-auto">
                  {leftContent}
                </BlockSection.NestedBlock>
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                  {rightContent}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock3.displayName = "HomepageBlock3";
